import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-shipping-receiving-tabs',
  templateUrl: './shipping-receiving-tabs.component.html',
  styleUrls: ['./shipping-receiving-tabs.component.css']
})
export class ShippingReceivingTabsComponent implements OnInit {
  @ViewChild('tabGroup', { static: true }) tabGroup: MatTabGroup;

  constructor(public sharedService: SharedService) { }

  ngOnInit(): void {
    this.sharedService.reloadUserPrivileges();
      //this.tabGroup.selectedIndex = 1;

    if (!this.sharedService.hasShippingAccess) {
      this.tabGroup.selectedIndex = 1;
    }
  }
}
